import { render, staticRenderFns } from "./EcCollapse.vue?vue&type=template&id=e36bc14e"
import script from "./EcCollapse.vue?vue&type=script&lang=js"
export * from "./EcCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports